import { ValueOf } from '../utilities/types';

const deviceTypes = {
  ELECTRONIC_ID: 'electronicId',
  HARDWARE_ID: 'hardwareId',
} as const;

export type DeviceTypes = ValueOf<typeof deviceTypes>;

export const deviceTypesChoices: { id: DeviceTypes; name: string }[] = [
  {
    id: deviceTypes.ELECTRONIC_ID,
    name: 'Electronic ID',
  },
  {
    id: deviceTypes.HARDWARE_ID,
    name: 'Hardware ID',
  },
];

export default deviceTypes;
